export const defaultSingleObjectState: SingleObjectState = {
  processing: false,
  processed: false,
  success: false,
  errors: {},
  data: {},
  message: "",
};

export const defaultSingleObjectPayload: Readonly<{
  data: GenericRecord;
  errors: Record<string, unknown>;
}> = {
  data: {},
  errors: {},
};

export const defaultManyObjectPayload = {
  data: [],
  errors: [],
  paginationMeta: {
    currentPage: 0,
    nextPage: null,
    previousPage: null,
    totalObjects: 0,
    totalPages: 0,
    maxObjectsPerPage: 0,
  },
};

export const defaultManyObjectState: ManyObjectState = {
  processing: false,
  processed: false,
  success: false,
  errors: {},
  data: [],
  message: "",
};

export const defaultPaginatedObjectState: ManyObjectState = {
  ...defaultManyObjectState,
  paginationMeta: {
    currentPage: 0,
    nextPage: null,
    previousPage: null,
    totalObjects: 0,
    totalPages: 0,
    maxObjectsPerPage: 0,
  },
};

export const DEFAULT_AVATAR_IMAGE = "/emptyStates/avatar.jpeg";

export const DEFAULT_POST_IMAGE =
  "https://redzonekickboxing.com/wp-content/uploads/2017/04/default-image.jpg";

export const IMAGE_USED_IN_STORY_DOCS =
  "https://avatars3.githubusercontent.com/u/38565349?s=60&v=4";
export const UNSPLASH_IMAGE_ONE =
  "https://images.unsplash.com/photo-1602696221981-75511960e2b6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=3334&q=80";

export const UNSPLASH_IMAGE_TWO =
  "https://images.unsplash.com/photo-1602609777860-f36a617a194f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80";

export const UNSPLASH_IMAGE_THREE =
  "https://images.unsplash.com/photo-1602731882832-9e04d741078f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80";
export const LINKEDIN = "https://www.linkedin.com/company/npo-hub";
export const TWITTER = "https://twitter.com/hubnpo?lang=en";
export const INSTAGRAM = "https://www.instagram.com/npo_hub/";

export const MassParts = [
  "All",
  "Entrance",
  "Lord have Mercy",
  "Glory be to God",
  "Responsorial Psalm",
  "Gospel Acclamation",
  "I Believe (Credo)",
  "Prayer of the Faithful",
  "Offertory",
  "Consecration",
  "Holy Holy Holy",
  "Lamb of God",
  "Communion",
  "Recessional",
];

export const seasons = [
  "Ordinary Time",
  "Advent",
  "Christmas",
  "Lent",
  "Easter",
  "Pentecost",
  "Feast Days",
];

export const others = [
  "Classical",
  "Marian",
  "Wedding",
  "Funeral",
  "Eucharistic Adoration",
  "Benediction",
  "Taize",
];

export const AllCategories = [...MassParts, ...seasons, ...others];
export const languages = ["Igbo", "Yoruba", "Hausa", "Other Lang"];

export const AUDIO_FILE_OPTIONS = [".mp3", ".wav", ".ogg"];
export const CURRENT_PAGE = "my-page";

export const userKey = "user-token";
export const userInfo = "user-detail-info";
export const statusOBJ = {
  PENDING: "Pending",
  APPROVED: "Published",
  REJECTED: "Cancelled",
};

export const QUERY_KEYS = {
  ADMIN_SCRIPTS: "GET_ADMIN_SCRIPTS",
  USER_ANALYTICS: "GET_USER_ANALYTICS",
  DOWNLOAD_HISTORY: "GET_DOWNLOAD_HISTORY",
  REVENUE_ANALYTICS: "GET_GENERATED_REVENUE",
  USER_SUMMARY: "GET_USER_SUMMARY",
  SUBSCRIPTION_PLAN: "GET_SUBSCRIPTION_PLAN",
};

export interface ScriptType {
  meta: string;
  id: string;
  name: string;
  composer: string;
  image: string;
  document: string;
  audio: string;
  composerId: string;
  videoUrl: string;
  keySignature: string;
  language: string;
  license: string;
  parts: string;
  uploadedBy: string;
  category: string;
  customCategory: string;
  description: string;
  slug: string;
  isVerified: string;
  ratingCount: number;
  averateRating: number;
  viewCount: number;
  downloadCount: number;
  favoriteCount: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  user: {
    userName: string;
    email: string;
  };
}

export interface UserType {
  id: string;
  userName: string;
  displayName: string;
  email: string;
  image: string;
  isVerified: string;
  status: string;
  resetPasswordToken: string;
  resetPasswordExpire: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  isSubscribed: string;
  subscribtion?: {
    startDate?: Date;
    endDate?: Date;
    userDownloadCount?: 0;
    status?: string;
  };
}
